import styled from 'styled-components';
import {getSpacing, getToken, getFontSize} from '@tickchak/react-share/app';
import {dFlex, alignCenter} from '../../../../globalVariables/GlobalFlex';
import {mobileMedia} from '../../../../globalVariables/GlobalVariables';

export const row = styled.div`
    ${dFlex};
    ${alignCenter};
    width: 100%;
    border-bottom: 1px solid ${getToken('color.border.subtle')};
    min-height: 40px;
    padding: ${getSpacing('spaceSm')} ${getSpacing('spaceLg')};

    &:last-child {
        border-bottom: none;
    }
    ${mobileMedia} {
        font-size: 16px;
    }
`;

export const contentEditable = styled.div`
    flex: 1;
    min-height: 20px;
    outline: none;
    color: ${getToken('color.text.default')};
    position: relative;
    font-size: ${getFontSize('bodySmall')};
    direction: ${p => p.theme.direction};
    -webkit-text-size-adjust: 100%;

    &[data-is-empty='true'] {
        color: ${getToken('color.state.warning.main')};
        font-weight: bold;
    }

    .variable {
        font-weight: var(--font-weight-bold);
        color: var(--primitive-turquoise-700);
    }

    strong {
        font-weight: bold;
    }

    em {
        font-style: italic;
    }
`;
